/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ContactEditorial/theme';

export const ContactEditorialTheme = theme;
